import React from "react";
import dayjs from "dayjs";
import GenericReportPage from "../../../components/common/GenericReportPage";
import { fmtQty } from "../../../utils/reportExport";

const STATUS_OPTIONS = [
    { value: "", label: "All Status" },
    { value: "Preparing", label: "Preparing" },
    { value: "Ready", label: "Ready" },
    { value: "Issued", label: "Issued" },
    { value: "Rejected", label: "Rejected" },
];

const IssueNotesReport = () => (
    <GenericReportPage
        title="Issue Notes Report"
        subtitle="Material issue notes with status, quantities and workflow users"
        breadcrumb={["Reports", "Inventory"]}
        fetchUrl="/reports/inventory/issue_notes.php"
        rowKey="iin_id"
        filterDefs={[
            { type: "search", key: "search", label: "Search", col: 6, placeholder: "IIN ref, MR ref" },
            { type: "select", key: "status", label: "Status", col: 4, options: STATUS_OPTIONS },
            { type: "date", key: "dateRange", label: "Prepared Date", col: 6 },
        ]}
        columns={[
            { title: 'IIN Ref', dataIndex: 'iin_ref', key: 'iin_ref', width: 130, sorter: (a, b) => (a.iin_ref || '').localeCompare(b.iin_ref || '') },
            { title: 'MR Ref', dataIndex: 'mr_ref', key: 'mr_ref', width: 130 },
            { title: 'Prepared Date', dataIndex: 'prepare_dt', key: 'prepare_dt', width: 120, render: (d) => d ? dayjs(d).format("YYYY-MM-DD") : "-", sorter: (a, b) => dayjs(a.prepare_dt).valueOf() - dayjs(b.prepare_dt).valueOf() },
            { title: 'Issued Date', dataIndex: 'collected_dt', key: 'collected_dt', width: 120, render: (d) => d ? dayjs(d).format("YYYY-MM-DD") : "-" },
            { title: 'Items', dataIndex: 'item_count', key: 'item_count', align: 'center', width: 80 },
            { title: 'Total Qty', dataIndex: 'total_qty', key: 'total_qty', align: 'right', width: 100, render: (v) => fmtQty(v) },
            { title: 'Status', dataIndex: 'iin_status', key: 'iin_status', width: 120 },
            { title: 'Prepared By', dataIndex: 'prepare_user_dname', key: 'prepare_user_dname', width: 130 },
            { title: 'Completed By', dataIndex: 'complete_user_dname', key: 'complete_user_dname', width: 130, render: (v) => v || "—" },
            { title: 'Collected By', dataIndex: 'collect_user_dname', key: 'collect_user_dname', width: 130, render: (v) => v || "—" },
        ]}
        pdf={{
            title: "MATERIAL ISSUE NOTES REPORT",
            subtitle: "Material issue notes with status, quantities and workflow users",
            columns: [
                { header: "IIN Ref" }, { header: "MR Ref" }, { header: "Prepared Date" }, { header: "Issued Date" },
                { header: "Items", align: "center" }, { header: "Total Qty", align: "right" }, { header: "Status" },
                { header: "Prepared By" }, { header: "Completed By" }, { header: "Collected By" },
            ],
            rows: (rows) =>
                rows.map((r) => [
                    r.iin_ref || "-",
                    r.mr_ref || "-",
                    r.prepare_dt ? dayjs(r.prepare_dt).format("YYYY-MM-DD") : "-",
                    r.collected_dt ? dayjs(r.collected_dt).format("YYYY-MM-DD") : "-",
                    String(r.item_count ?? ""),
                    fmtQty(r.total_qty),
                    r.iin_status || "-",
                    r.prepare_user_dname || "-",
                    r.complete_user_dname || "-",
                    r.collect_user_dname || "-",
                ]),
            columnStyles: { 5: { halign: "right" } },
        }}
        excel={{
            filename: "issue-notes-report",
            sheetName: "Issue Notes",
            columns: [
                { title: "IIN Ref", dataIndex: "iin_ref", width: 14 },
                { title: "MR Ref", dataIndex: "mr_ref", width: 14 },
                { title: "Prepared Date", dataIndex: "prepare_dt", width: 13 },
                { title: "Issued Date", dataIndex: "collected_dt", width: 13 },
                { title: "Items", dataIndex: "item_count", width: 8 },
                { title: "Total Qty", dataIndex: "total_qty", width: 10 },
                { title: "Status", dataIndex: "iin_status", width: 14 },
                { title: "Prepared By", dataIndex: "prepare_user_dname", width: 16 },
                { title: "Completed By", dataIndex: "complete_user_dname", width: 16 },
                { title: "Collected By", dataIndex: "collect_user_dname", width: 16 },
            ],
            rows: (rows) =>
                rows.map((r) => ({
                    ...r,
                    prepare_dt: r.prepare_dt ? dayjs(r.prepare_dt).format("YYYY-MM-DD") : "",
                    collected_dt: r.collected_dt ? dayjs(r.collected_dt).format("YYYY-MM-DD") : "",
                    total_qty: fmtQty(r.total_qty),
                })),
        }}
    />
);

export default IssueNotesReport;
